import { sendGTMEvent } from '@next/third-parties/google';

function getDiscount(original_price, price) {
  return original_price !== price && price !== 0 ? original_price - price : 0;
}

function getTotalDiscount(products) {
  return products?.reduce((curr, item) => {
    return (
      curr +
      ((item?.prices_with_tax?.original_price ||
        item?.extension_attributes?.original_price ||
        item?.prices?.original_price ||
        item?.original_price) -
        (item?.prices_with_tax?.final_price ||
          item?.prices_with_tax?.price ||
          item?.extension_attributes?.special_price ||
          item?.prices?.price ||
          item?.price))
    );
  }, 0);
}

function getTotalPrices(products) {
  return products?.reduce(
    (price, cur) =>
      (cur?.prices_with_tax?.price || cur?.price_incl_tax) * (cur?.qty || 1) +
      price,
    0
  );
}

function getProductCategories(product) {
  return {
    ...((product?._category_?.main_category ||
      product?.extension_attributes?.category_names?.at(0)) && {
      item_catgory:
        product?._category_?.main_category?.name ||
        product?.extension_attributes?.category_names?.at(0)?.name,
      item_list_name:
        product?._category_?.main_category?.name ||
        product?.extension_attributes?.category_names?.at(0)?.name,
      item_list_id:
        product?._category_?.main_category?.category_id ||
        product?.extension_attributes?.category_names?.at(0)?.id,
    }),
    ...((product?._category_?.sub_categories?.at(0)?.name ||
      product?.extension_attributes?.category_names?.at(1)) && {
      item_catgory_2:
        product?._category_?.sub_categories?.at(0)?.name ||
        product?.extension_attributes?.category_names?.at(1)?.name,
    }),
    ...((product?._category_?.sub_categories?.at(1)?.name ||
      product?.extension_attributes?.category_names?.at(2)) && {
      item_catgory_3:
        product?._category_?.sub_categories?.at(1)?.name ||
        product?.extension_attributes?.category_names?.at(2)?.name,
    }),
    ...((product?._category_?.sub_categories?.at(2)?.name ||
      product?.extension_attributes?.category_names?.at(3)) && {
      item_catgory_4:
        product?._category_?.sub_categories?.at(2)?.name ||
        product?.extension_attributes?.category_names?.at(3)?.name,
    }),
    ...((product?._category_?.sub_categories?.at(3)?.name ||
      product?.extension_attributes?.category_names?.at(4)) && {
      item_catgory_5:
        product?._category_?.sub_categories?.at(3)?.name ||
        product?.extension_attributes?.category_names?.at(4)?.name,
    }),
  };
}

function getItemBrand(product) {
  return {
    ...(((Array.isArray(product?.option_text_brands) &&
      product?.option_text_brands?.length > 0) ||
      product?.extension_attributes?.brand_name) && {
      item_brand:
        product?.option_text_brands?.[0] ||
        product?.extension_attributes?.brand_name,
    }),
  };
}

function getLineItems(items) {
  return {
    line_items: items?.map((item, i) => {
      return {
        item_id: item?.extension_attributes?.product_sku || item?.sku,
        item_name: Array.isArray(item?.name) ? item?.name?.[0] : item?.name,
        discount: Number(getTotalDiscount([item])).toFixed(2),
        ...getItemBrand(item),
        ...getProductCategories(item),
        shelf_price: Number(
          item?.extension_attributes?.original_price ||
            item?.extension_attributes?.original_price ||
            item?.original_price ||
            item?.prices_with_tax?.original_price
        ).toFixed(2),
        price: Number(
          item?.price_incl_tax ||
            item?.price_incl_tax ||
            item?.prices_with_tax?.final_price ||
            item?.prices_with_tax?.price
        ).toFixed(2),
        quantity: item?.qty || item?.qty_ordered || 1,
        index: i + 1,
        item_availability: item?.stock?.is_in_stock || true,
        item_link:
          process.env.NEXT_PUBLIC_WEBSITE_URL +
          `product/${item?.rewrite_url || item?.extension_attributes?.url_key || item?.extension_attributes?.rewrite_url}`,
        item_image_link:
          item?._media_?.image?.[0]?.image ||
          `${process.env.NEXT_PUBLIC_IMG_BASEURL}/catalog/product/${item?.extension_attributes?.product_image}`,
      };
    }),
  };
}

function getBasicPromotions(promotion) {
  return {
    creative_name: promotion?.promotionImage,
    creative_slot: promotion?.key,
    location_id: promotion?.position,
    promotion_id: promotion?.id,
    promotion_name: promotion?.name,
  };
}

const gtmEvent = (event, data, user) => {
  if (typeof window != undefined) {
    sendGTMEvent({
      event: event,
      ecommerce: { ...data, ...(user && { ...user }) },
    });
  }
};

// Event Shipping Info
export const event_shipping_info = (cartData, shipping_tier) => {
  return gtmEvent('add_shipping_info', {
    currency: 'SAR',
    value: cartData?.grand_total,
    shipping_tier,
    ...getLineItems(cartData?.items),
    number_of_products: cartData?.items?.length,
    item_id: cartData?.items
      ?.map((item) => item?.extension_attributes?.product_sku)
      .join(','),
    item_name: cartData?.items?.map((item) => item?.name).join(','),
  });
};

// Event Payment Info
export const event_payment_info = (cartData, payment_type) => {
  return gtmEvent('add_payment_info', {
    currency: 'SAR',
    value: cartData?.grand_total,
    payment_type,
    ...getLineItems(cartData?.items),
    number_of_products: cartData?.items?.length,
    item_id: cartData?.items
      ?.map((item) => item?.extension_attributes?.product_sku)
      .join(','),
    item_name: cartData?.items?.map((item) => item?.name).join(','),
  });
};

// Event View Item List
// used in category page
export const event_view_item_list = (currentCategory, products) => {
  gtmEvent('category_click', {
    category_id: String(currentCategory?.id),
    category_name: currentCategory?.name,
    product_count: currentCategory?.product_count,
  });
  gtmEvent('view_item_list', {
    currency: 'SAR',
    ...getLineItems(products),
  });
};

// Event Sub Category View
export const event_sub_view_item_list = (
  parentCategory,
  subCategory,
  products
) => {
  gtmEvent('view_item_list', {
    currency: 'SAR',
    ...getLineItems(products),
  });
  return gtmEvent('category_click', {
    category_id: String(parentCategory?.id),
    category_name: parentCategory?.name,
    category2_id: String(subCategory?.id),
    category2_name: subCategory?.name,
    product_count: subCategory?.product_count,
  });
};

// Login, Logout, Register Event
export const event_user_auth = (user, event_name, method) => {
  const { firstname, lastname, email, id, mobilenumber, created_at } =
    user || {};
  const userData = {
    firstname,
    lastname,
    ...(id && { user_id: id }),
    ...(email ? { email } : {}),
    ...(mobilenumber ? { mobilenumber } : {}),
    method,
    status:
      method === 'register'
        ? 'User Registered Successfully'
        : 'User LoggedIn Successfully',
    referral_url: window.location.origin,
    event_source: 'Website',
    user_type: 'Customer',
    account_creation_date: created_at || new Date().toISOString(),
  };
  return gtmEvent(event_name, userData);
};

// Banner Clicked
// used in swiper, each banner in home page
export const banner_event = (banner_name, banner_link) => {
  return gtmEvent('banner_clicked', {
    banner_link,
    banner_name,
  });
};

export const update_wishlists_event = (products) => {
  return gtmEvent('wishlist_updated', {
    line_items: products?.map((item) => {
      const discount = getDiscount(
        item?.prices_with_tax?.original_price,
        item?.prices_with_tax?.price
      );
      return {
        category_name: item?._category_?.main_category?.name,
        sub_category_name: item?._category_?.sub_categories?.[0]?.name,
        sku_name: item?.sku,
        product_image: item?._media_?.image?.[0]?.image,
        quantity: 1,
        price: item?.prices_with_tax?.price,
        ...(discount !== 0 && !isNaN(discount) && { discount }),
      };
    }),
    number_of_products: products?.length,
    item_id: products?.map((item) => item?.sku).join(','),
    item_name: products?.map((item) => item?.name?.[0]).join(','),
    value: products?.reduce(
      (price, cur) => cur?.prices_with_tax?.price + price,
      0
    ),
  });
};

// Language Change Event
export const change_language_event = (language) => {
  return gtmEvent('language_change', {
    language,
  });
};

// Payment Failure
export const payment_failure_event = (
  amount,
  mode,
  number_of_products,
  payment,
  reason
) => {
  return gtmEvent('payment_failed', {
    amount,
    mode,
    number_of_products,
    ...(payment && { payment }),
    ...(reason && { reason }),
  });
};

// Select Item Event
export const select_item_event = (product) => {
  return gtmEvent('select_item', {
    currency: 'SAR',
    ...getLineItems([product]),
  });
};

// Event For Search Page
export const event_search_result_item_list = (
  inputSearchValue,
  total_items
) => {
  gtmEvent('search_term', {
    search_term: inputSearchValue,
    search_results_count: total_items,
  });
};

// Event View Item used in pdp
export const event_view_item = (product) => {
  return gtmEvent('view_item', {
    currency: 'SAR',
    value: Number(
      product?.prices_with_tax?.price ||
        product?.prices_with_tax?.original_price
    ).toFixed(2),
    ...getLineItems([product]),
  });
};

// Event Add, Update Cart
export const event_add_to_cart = (product, qty) => {
  return gtmEvent('add_to_cart', {
    currency: 'SAR',
    value: Number(
      qty *
        (product?.price_incl_tax ||
          product?.extension_attributes?.original_price ||
          product?.prices_with_tax?.final_price ||
          product?.prices_with_tax?.price ||
          product?.prices_with_tax?.original_price)
    ).toFixed(2),
    ...getLineItems([product]),
  });
};

// Event Remove From Cart
// used in mini cart, cart popup, cart page
export const event_remove_from_cart = (product) => {
  return gtmEvent('remove_from_cart', {
    currency: 'SAR',
    value: Number(
      product?.qty *
        (product?.price_incl_tax ||
          product?.extension_attributes?.original_price ||
          product?.prices_with_tax?.final_price ||
          product?.prices_with_tax?.price ||
          product?.prices_with_tax?.original_price)
    ).toFixed(2),
    ...getLineItems([product]),
  });
};

// Update cart Item
export const update_cart_event = (cartItems) => {
  return gtmEvent('cart_updated', {
    ...getLineItems(cartItems),
    total_discounts: Number(getTotalDiscount(cartItems)).toFixed(2),
    number_of_products: cartItems?.length,
    item_id: cartItems
      ?.map((item) => item?.sku || item?.extension_attributes?.product_sku)
      .join(','),
    item_name: cartItems
      ?.map((item) =>
        Array.isArray(item?.name) ? item?.name?.[0] : item?.name
      )
      .join(','),
    value: Number(getTotalPrices(cartItems)).toFixed(2),
    currency: 'SAR',
  });
};

// Event View Cart
export const event_view_cart = (cartData) => {
  return gtmEvent('view_cart', {
    currency: 'SAR',
    value: Number(cartData?.grand_total).toFixed(2),
    total_discounts: Number(getTotalDiscount(cartData?.items)).toFixed(2),
    item_id: cartData?.items
      ?.map((item) => item?.extension_attributes?.product_sku)
      .join(','),
    item_name: cartData?.items?.map((item) => item?.name).join(','),
    ...getLineItems(cartData?.items),
  });
};

// Begin Checkout
export const event_checkout_started = (cartData) => {
  return gtmEvent('begin_checkout', {
    currency: 'SAR',
    value: Number(cartData?.grand_total).toFixed(2),
    number_of_products: cartData?.items?.length,
    item_id: cartData?.items
      ?.map((item) => item?.extension_attributes?.product_sku)
      .join(','),
    item_name: cartData?.items?.map((item) => item?.name).join(','),
    ...getLineItems(cartData?.items),
  });
};

// Event Shipping Info
export const event_contact_info = (cartData) => {
  return gtmEvent('add_contact_info', {
    currency: 'SAR',
    value: cartData?.grand_total,
    number_of_products: cartData?.items?.length,
    item_id: cartData?.items
      ?.map((item) => item?.extension_attributes?.product_sku)
      .join(','),
    item_name: cartData?.items
      ?.map((item) =>
        Array.isArray(item?.name) ? item?.name?.[0] : item?.name
      )
      .join(','),
    ...getLineItems(cartData?.items),
  });
};

// Event For Success Page
export const event_purchase = (
  order,
  session,
  email,
  firstname,
  lastname,
  telephone
) => {
  return gtmEvent(
    'purchase',
    {
      order_id: order?.increment_id,
      transaction_id: order?.increment_id,
      value: order?.grand_total,
      tax: order?.tax_amount,
      shipping: order?.shipping_amount,
      currency: 'SAR',
      payment_type: order?.payment?.method,
      shipping_mode: 'Home Delivery',
      region: order?.billing_address?.city || '',
      street: order?.billing_address?.street?.[0] || '',
      ...getLineItems(order?.items),
      number_of_products: order?.items?.length,
      item_id: order?.items?.map((item) => item?.sku).join(','),
      item_name: order?.items
        ?.map((item) =>
          Array.isArray(item?.name) ? item?.name?.[0] : item?.name
        )
        .join(','),
    },
    session?.user
      ? session
      : {
          user: {
            firstname,
            lastname,
            email,
            custom_attributes: [
              { attribute_code: 'mobile_number', value: telephone },
            ],
          },
        }
  );
};

// Event Add To Wishlist, Remove From Wishist
export const event_toggle_wishlist = (product, event_name) => {
  return gtmEvent(event_name, {
    currency: 'SAR',
    value:
      product?.price_incl_tax ||
      product?.extension_attributes?.original_price ||
      product?.prices_with_tax?.price ||
      product?.prices_with_tax?.original_price,
    ...getLineItems([product]),
  });
};

// used in cart page
export const coupon_redemption = (code, is_success = true) =>
  gtmEvent('coupon_redemption', {
    code,
    redemption_result: is_success ? 'Coupon Success' : 'Coupon Failed',
  });

// used for each banner in home page on view
export const event_view_promotion = (promotions) => {
  return gtmEvent('view_promotion', {
    items: promotions?.map((promotion) => ({
      ...getBasicPromotions(promotion),
    })),
  });
};

// used for each banner in home page on click
export const event_select_promotion = (promotion) => {
  return gtmEvent('select_promotion', {
    items: [
      {
        ...getBasicPromotions(promotion),
        promotion_destination: window.location.origin + promotion?.url,
      },
    ],
  });
};

// Event Global Variable
export const event_global_variables = ({
  session,
  store_language,
  page_type,
}) => {
  const phone = session?.user
    ? session?.user?.custom_attributes?.find((info) =>
        info?.attribute_code?.includes('mobile')
      )?.value
    : null;
  return gtmEvent('global_variables', {
    ...(session?.user?.id ? { user_id: session?.user?.id } : {}),
    user_type: session ? 'Customer' : 'Guest',
    store: 'KSA',
    event_source: 'Website',
    ...(page_type ? { page_type } : {}),
    ...(store_language ? { store_language } : {}),
    ...(session?.user
      ? {
          phone: '+966'.concat(phone?.slice(-9)),
        }
      : {}),
    ...(session?.user ? { email: session?.user?.email } : {}),
  });
};

// used in error boundry event
export const event_error_boundry = (error_mesage, page_name) => {
  return gtmEvent('errors', {
    items: [
      {
        error_mesage,
        error_location: history.length > 1 ? document.reference : null,
        error_type: 'Something went wrong',
        page_name,
      },
    ],
  });
};
